<div class="col-lg-3 col-md-3 col-sm-4 nopadding-mobile">
  <div class="sidebar-header">
    <div class="sidebar-user-image">
      <div class="profile-pic-sidebar"><img src="{{me.organisationImage}}"
          *ngIf="me != null && me.organisationImage != null">
      </div>
    </div>

    <div class="sidebar-user-name">
      <div class="sidebar-user-firstname">{{me.organisation}}</div>
    </div>

    <div class="clear"></div>

    <div class="business-user-wrapper">
      <div class="business-user-member" *ngIf="me.isBusinessUser === true">MB for Business</div>
      <div class="business-user-member" *ngIf="me.isBusinessUser === false">MB for Work</div>
      <div class="account-mbno">
        <div class="business-user-org-name">
          {{me.organisationNo}}
        </div>
      </div>
    </div>
  </div>

  <div class="sidebar-nav">
    <div class="navbar navbar-default" role="navigation">
      <div class="navbar-header">
        <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".sidebar-navbar-collapse">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <span class="visible-xs navbar-brand">MENU</span>
      </div>

      <div class="navbar-collapse collapse sidebar-navbar-collapse">
        <ul class="nav navbar-nav" id="sidenav01">
          <li>
            <a [ngClass]="{'nav-selected': selectedTab==='dashboard'}" routerLink="/" class="nav-selected">
              <span class="glyphicon glyphicon-home"></span>Dashboard
            </a>
          </li>
          <li>
            <a [ngClass]="{'nav-selected': selectedTab==='personal-details'}" routerLink="/personal-details">
              <span class="glyphicon glyphicon-list-alt"></span> Details
            </a>
          </li>
          <li>
            <a [ngClass]="{'nav-selected': selectedTab==='session-options'}" routerLink="/session-options"
              *ngIf="me.isBusinessUser">
              <span class="glyphicon glyphicon-dashboard"></span> Session Options
            </a>
          </li>
          <li>
            <a [ngClass]="{'nav-selected': selectedTab==='contracts'}" routerLink="/contracts">
              <span class="glyphicon glyphicon-time"></span> Contracts
            </a>
          </li>
          <li>
            <a [ngClass]="{'nav-selected': selectedTab==='clients'}" routerLink="/clients">
              <span class="glyphicon glyphicon-comment"></span> Clients
            </a>
          </li>
          <li>
            <a [ngClass]="{'nav-selected': selectedTab==='professionals'}" routerLink="/professionals"
              *ngIf="me.isBusinessUser">
              <span class="glyphicon glyphicon-gbp"></span> Professionals
            </a>
          </li>
          <li>
            <a [ngClass]="{'nav-selected': selectedTab==='settings'}" routerLink="/settings">
              <span class="glyphicon glyphicon-cog"></span> Settings
            </a>
          </li>
        </ul>
      </div>
      <!--/.nav-collapse -->
    </div>
  </div>
</div>
